import {PaymentCodeEnum, PayoutWebModel} from "../../payments";

abstract class BasicBtcBitPayoutModel extends PayoutWebModel {

    required = [
        ...this.getRequired(),
        'amount', 'description', 'fromAccount',
        'verificationType',

        'state',
        'wallet_email', 'name', 'surname', 'country', 'city', 'address', 'zip', 'code', 'phone', 'email'
    ]

    values = {
        ...this.getValues(),
        fromAccount: '', amount: '',
        verificationType: '', autosplit: false, destinationAccount: '',
        description: '',

        state: '',
        wallet_email: '', name: '', surname: '', country: '', city: '', address: '', zip: '', code: '', phone: '', email: ''
    }
}

export class NetellerBtcBitPayoutModel extends BasicBtcBitPayoutModel {
    systemName = PaymentCodeEnum.Neteller
}

export class SkrillBtcBitPayoutModel extends BasicBtcBitPayoutModel {
    systemName = PaymentCodeEnum.Skrill
}